import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import db from "../../../constants/database"; 

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsentVersion = localStorage.getItem("cookie_policy_version");

    if (!savedConsentVersion || savedConsentVersion < db.legal.cookiePolicyVersion) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_policy_version", db.legal.cookiePolicyVersion);
    localStorage.setItem("consent_timestamp", new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-5px_25px_rgba(0,0,0,0.1)] z-[9999] p-4 md:py-6">
      <div className="max-w-[1250px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6 px-3">
        
        <div className="text-sm md:text-base text-[#272727] font-abel leading-relaxed">
          <p>
            We use cookies to improve your experience. By continuing to browse, you agree to our 
            <Link to="/policy" className="text-[#243677] font-bold hover:underline mx-1">
              Privacy Policy
            </Link> 
            and 
            <Link to="/terms" className="text-[#243677] font-bold hover:underline mx-1">
              Terms
            </Link>.
          </p>
          <p className="text-[11px] md:text-[12px] text-gray-400 mt-1">
            Policy Version: {db.legal.cookiePolicyVersion} | Last Updated: {db.legal.privacyLastUpdated}
          </p>
        </div>

        <div className="flex items-center gap-4 shrink-0">
          <button 
            onClick={handleAccept}
            className="bg-[#243677] text-white px-10 py-2 rounded-md font-bold hover:bg-opacity-90 transition-all text-sm md:text-base"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;

// const CookieBanner: React.FC = () => {
//   return <div style={{position: 'fixed', top: 0, background: 'red', zIndex: 9999}}>TESTING BANNER</div>;
// };
// export default CookieBanner;